import { render, staticRenderFns } from "./yatlgz.vue?vue&type=template&id=bbf21b56&scoped=true"
import script from "./yatlgz.vue?vue&type=script&lang=js"
export * from "./yatlgz.vue?vue&type=script&lang=js"
import style0 from "./yatlgz.vue?vue&type=style&index=0&id=bbf21b56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf21b56",
  null
  
)

export default component.exports